const showSuccessToast = (self, message) => {
  self.$toast.clear()
  self.$toast.success(message)
}
  
const showErrorToast = (self, message) => {
  self.$toast.clear()
  self.$toast.error(message)
}
exports = module.exports = {
  showSuccessToast,
  showErrorToast
}
